import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import { apiClient } from "@/shared/services/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Field, FieldLabel } from "@/components/ui/field";
import { PasswordInput } from "@/shared/components/PasswordInput";

export function AcceptMembershipInvitation() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const accept = async () => {
    if (!token) return setError("This invitation link is incomplete.");
    if (password && password !== confirmation) return setError("Passwords do not match.");
    setBusy(true);
    setError("");
    try {
      await apiClient.post(`/mobile/membership-invitations/${encodeURIComponent(token)}/accept`, {
        newPassword: password || null,
      });
      setSuccess(true);
    } catch (reason) {
      const response = reason as { response?: { data?: { userMessage?: string; message?: string } } };
      setError(response.response?.data?.userMessage ?? response.response?.data?.message ?? "This invitation could not be accepted.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader><CardTitle>Accept FarmSmart access</CardTitle><CardDescription>Join the customer account that invited you. New users must create a password; existing users can leave these fields empty.</CardDescription></CardHeader>
        <CardContent className="space-y-4">
          {success ? (
            <div className="space-y-4"><p className="text-sm text-emerald-700">Your access is active. You can now sign in to the FarmSmart mobile app.</p><Button asChild className="w-full"><Link to="/login">Continue to login</Link></Button></div>
          ) : (
            <>
              <Field><FieldLabel>New password</FieldLabel><PasswordInput value={password} onChange={(event) => setPassword(event.target.value)} autoComplete="new-password" /></Field>
              <Field><FieldLabel>Confirm password</FieldLabel><PasswordInput value={confirmation} onChange={(event) => setConfirmation(event.target.value)} autoComplete="new-password" /></Field>
              {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
              <Button className="w-full" disabled={busy} onClick={() => void accept()}>{busy ? "Accepting…" : "Accept Invitation"}</Button>
            </>
          )}
        </CardContent>
      </Card>
    </main>
  );
}
